module.exports = require("./crossfilter").crossfilter;



//////////////////
// WEBPACK FOOTER
// ../graylog2-server/graylog2-web-interface/~/crossfilter/index.js
// module id = 56
// module chunks = 0